import React from 'react';
import { Card, CardBody, Spinner } from 'reactstrap';
import Exitimg from '../../../../assets/images/if_dash/Background.png';

function ExitCamera({ data, statsLoader, handleImageClick }) {
  return (
    <Card>
      <CardBody style={{ padding: "20px", borderRadius: "8px" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h2 style={{ fontSize: "20px", color: "#1D67AA", fontWeight: "600" }}>
              Exit Camera Live Feed
            </h2>
          </div>
          <div>
            <p style={{ fontSize: "14px", fontWeight: "400", color: "#6B7280" }}>
              {new Date().toLocaleString()}
            </p>
          </div>
        </div>

        {/* Spinner or Image */}
        {statsLoader ? (
          <div style={{ height: "364px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Spinner color="success" />
          </div>
        ) : (
          <img
            style={{ width: "100%", height: "364px", paddingBottom: "20px" }}
            src={data?.image_url || "https://via.placeholder.com/600x364"}
            alt="Entry Camera Feed"
            onClick={()=>handleImageClick(data?.image_url)}
          />
        )}
      </CardBody>
    </Card>
  );
}

export default ExitCamera;
